'use strict';

angular.module('licensure.services')
    .factory('FileTypes', ['$http', '$q', function ($http, $q) {
        var get = function (enterprise) {
            var d = $q.defer();

            $http.get(apiLocation + '/api/FileTypes', {
                params: {
                    enterprise: enterprise
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        return {
            get: get,

            getByEnterprise: function () {
                return get(true);
            }
        }
    }])
;